import { API_BASE_URL } from "../config/api";
import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { clearAuthSession } from "../utils/auth";

export default function AccountsLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setIsSubmitting(true);

    try {
      const res = await axios.post(API_BASE_URL + "/api/auth/login", {
        email,
        password
      });

      if (res.data.role !== "accounts") {
        setErrorMessage("This account does not have accounts access.");
        setIsSubmitting(false);
        return;
      }

      clearAuthSession();
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("role", "accounts");
      localStorage.setItem("accountsName", res.data.name || "Accounts");
      localStorage.setItem("accountsEmail", res.data.email || email);
      localStorage.setItem("accountsSession", "active");

      window.location.href = "/accounts-dashboard";
    } catch (error) {
      setErrorMessage(error.response?.data?.message || "Login failed");
      setIsSubmitting(false);
    }
  };

  return (
    <div className="theme-login-shell relative flex min-h-screen items-center justify-center overflow-hidden bg-[linear-gradient(135deg,_#1c1917,_#451a03,_#fef3c7)] px-4">
      <div className="absolute left-[-6rem] top-10 h-72 w-72 rounded-full bg-amber-300/20 blur-3xl" />
      <div className="absolute bottom-0 right-[-4rem] h-80 w-80 rounded-full bg-yellow-200/20 blur-3xl" />

      <form
        onSubmit={handleLogin}
        className="theme-login-card relative w-full max-w-md rounded-[2rem] border border-white/20 bg-white/95 p-8 shadow-2xl backdrop-blur"
      >
        <p className="text-center text-xs font-semibold uppercase tracking-[0.4em] text-amber-700">
          Genmech Service
        </p>
        <h1 className="mt-4 text-center text-3xl font-black text-stone-950">
          Accounts Workspace Login
        </h1>
        <p className="mt-3 text-center text-sm leading-6 text-stone-600">
          Sign in to review complaints, reports, customer activity, and accounts updates.
        </p>

        <div className="mt-8 space-y-5">
          <div>
            <label className="mb-2 block text-sm font-semibold text-stone-700">Email</label>
            <input
              type="email"
              placeholder="accounts@genmech.com"
              className="w-full rounded-2xl border border-amber-200 px-4 py-3 outline-none transition focus:border-amber-500 focus:ring-4 focus:ring-amber-100"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div>
            <label className="mb-2 block text-sm font-semibold text-stone-700">Password</label>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password"
              className="w-full rounded-2xl border border-amber-200 px-4 py-3 outline-none transition focus:border-amber-500 focus:ring-4 focus:ring-amber-100"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword((current) => !current)}
              className="mt-2 text-sm font-medium text-amber-700 transition hover:text-amber-800"
            >
              {showPassword ? "Hide Password" : "Show Password"}
            </button>
          </div>

          {errorMessage ? (
            <div className="rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700">
              {errorMessage}
            </div>
          ) : null}
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          className="mt-8 w-full rounded-2xl bg-amber-500 px-4 py-3 font-semibold text-stone-950 transition hover:bg-amber-400 disabled:cursor-not-allowed disabled:bg-amber-200"
        >
          {isSubmitting ? "Signing In..." : "Login"}
        </button>

        <div className="mt-6 text-center text-sm">
          <Link to="/" className="font-semibold text-amber-700 transition hover:text-amber-800">
            Back to role select
          </Link>
        </div>
      </form>
    </div>
  );
}


